import React from 'react';
import {number, oneOfType, string, node, ReactNodeLike} from 'prop-types';
import MUITableCell from '@material-ui/core/TableCell';

import {ColumnType} from './tableTypes';

interface TableCellProps extends ColumnType {
    children?: ReactNodeLike
}

export default function TableCell({dataKey, title, children}: TableCellProps) {
    if (children) {
        return (
            <MUITableCell
                key={dataKey}
                align="left"
            >
                {children}
            </MUITableCell>
        );
    }
    
    return (
        <MUITableCell
            key={dataKey}
            align="left"
        >
            {title}
        </MUITableCell>
    );
}

TableCell.defaultProps = {
    title: '',
    children: null,
};

TableCell.propTypes = {
    dataKey: string.isRequired,
    title: oneOfType([
        string,
        number,
    ]),
    children: node,
};
